import type { DashboardFilters } from '@linka/domain/dtos';

export const eventDashboardKeys = {
  all: ['dashboard'] as const,
  event: (id: string, params?: DashboardFilters) => [...eventDashboardKeys.all, id, params] as const,
  sessions: (eventId: string, date?: string) => [...eventDashboardKeys.event(eventId), 'sessions', date] as const,
  sessionParticipants: (eventId: string, params?: { sessionId?: string }) =>
    [...eventDashboardKeys.event(eventId), 'sessions', 'participants', params] as const,
};
